const defaultForm = {
  name: '',
  category: 'UTILITY',
  language: 'es_AR',
  header: '',
  body: '',
  footer: '',
  parameterBindings: {},
};

const createDefaultForm = () => ({
  ...defaultForm,
  parameterBindings: {},
});

const initialState = {
  isLoading: false,
  error: null,
  templates: [],
  addTemplateModal: {
    isOpen: false,
    step: 0,
    isSubmitting: false,
    form: createDefaultForm(),
    createResponse: null,
    variables: [],
    previewTemplate: null,
    contentValidationErrors: null,
  },
  editTemplateModal: {
    isOpen: false,
    step: 0,
    isSubmitting: false,
    isLoadingTemplate: false,
    isFormDirty: false,
    templateId: null,
    form: createDefaultForm(),
    parameters: [],
    variables: [],
    updateResponse: null,
    previewTemplate: null,
    contentValidationErrors: null,
  },
};

export default initialState;

export { createDefaultForm };
